import {Action} from "@ngrx/store";
import {IMDMHierarchy, IMDMLevel, IMDMType} from "@retail-data-factory/rdf-angular-types-api";

export enum EMDMActions {
  ClearMDMStore = '[MDM] Clear MDM store',
  InitMDMStore = '[MDM] Init MDM store',
  //Получение списка типов
  LoadTypes = '[MDM] Load types',
  LoadTypesSuccess = '[MDM] Load types success',
  LoadTypesFailure = '[MDM] Load types failure',

  LoadAllHierarchy = '[MDM] Load all hierarchy list',
  LoadAllHierarchySuccess = '[MDM] Load all hierarchy list success',
  LoadAllHierarchyFailure = '[MDM] Load all hierarchy list failure',
  //Получение списка иерархий для конкретного типа
  LoadHierarchyList = '[MDM] Load hierarchy list',
  LoadHierarchyListSuccess = '[MDM] Load hierarchy list success',
  LoadHierarchyListFailure = '[MDM] Load hierarchy list failure',

  //Получение списка уровней для конкретной иерарархии
  LoadHierarchyLevels = '[MDM] Load hierarchy levels',
  LoadHierarchyLevelsSuccess = '[MDM] Load hierarchy levels success',
  LoadHierarchyLevelsFailure = '[MDM] Load hierarchy levels failure',

  //Получение списка элементов для конкретного уровня конкретной иерархии
  LoadHierarchyDetail = '[MDM] Load hierarch detail',
  LoadHierarchyDetailSuccess = '[MDM] Load hierarch detail success',
  LoadHierarchyDetailFailure = '[MDM] Load hierarch detail failure',

  StartMdmLoadingProgression = '[MDM] Start Mdm Loading Progression',
  FinishStageMdmLoadingProgression = '[MDM] Finish Stage MdmLoading Progression',
  FinishAllMdmLoadingProgression = '[MDM] Finish All Mdm Loading Progression'


}
export class ClearMDMStore implements Action {
  public readonly type = EMDMActions.ClearMDMStore;
}

export class InitMDMStore implements Action {
  public readonly type = EMDMActions.InitMDMStore;
}
//----------------------------------------------------
export class LoadTypes implements Action {
  public readonly type = EMDMActions.LoadTypes;
}
export class LoadTypesSuccess implements Action {
  public readonly type = EMDMActions.LoadTypesSuccess;
  constructor(public payload: Array<IMDMType>) {}
}
export class LoadTypesFailure implements Action {
  public readonly type = EMDMActions.LoadTypesFailure;
}


//----------------------------------------------------
export class LoadAllHierarchy implements Action {
  public readonly type = EMDMActions.LoadAllHierarchy;
  constructor(public payload: Array<{typeCode: string}>) {}
}
export class LoadAllHierarchySuccess implements Action {
  public readonly type = EMDMActions.LoadAllHierarchySuccess;
  constructor(public payload: Array<IMDMHierarchy>) {}
}
export class LoadAllHierarchyFailure implements Action {
  public readonly type = EMDMActions.LoadAllHierarchyFailure;
}


//----------------------------------------------------
export class LoadHierarchyList implements Action {
  public readonly type = EMDMActions.LoadHierarchyList;
  constructor(public payload: {typeCode: string}) {}
}
export class LoadHierarchyListSuccess implements Action {
  public readonly type = EMDMActions.LoadHierarchyListSuccess;
  constructor(public payload: Array<IMDMHierarchy>) {}
}
export class LoadHierarchyListFailure implements Action {
  public readonly type = EMDMActions.LoadHierarchyListFailure;
}

//----------------------------------------------------
export class LoadHierarchyLevels implements Action {
  public readonly type = EMDMActions.LoadHierarchyLevels;
  //в параметрах передается тип mdm
  constructor(public payload: {typeCode: string, hierCode: string}) {}
}
export class LoadHierarchyLevelsSuccess implements Action {
  public readonly type = EMDMActions.LoadHierarchyLevelsSuccess;
  constructor(public payload: {hierTypeCode: string; hierCode: string; levels: Array<IMDMLevel>}) {}
}
export class LoadHierarchyLevelsFailure implements Action {
  public readonly type = EMDMActions.LoadHierarchyLevelsFailure;
}

//----------------------------------------------------
export class LoadHierarchyDetail implements Action {
  public readonly type = EMDMActions.LoadHierarchyDetail;
  //в параметрах передается тип mdm
  constructor(public payload: {typeCode: string, hierCode: string, levelCode: string}) {}
}
export class LoadHierarchyDetailSuccess implements Action {
  public readonly type = EMDMActions.LoadHierarchyDetailSuccess;
  constructor(public payload: {hierTypeCode: string; hierCode: string; levels: Array<IMDMLevel>}) {}
}
export class LoadHierarchyDetailFailure implements Action {
  public readonly type = EMDMActions.LoadHierarchyDetailFailure;
}
export class StartMdmLoadingProgression implements Action{
  public readonly type = EMDMActions.StartMdmLoadingProgression;
  constructor(public payload:{stages:number}) {}
}
export class FinishStageMdmLoadingProgression implements Action{
  public readonly type = EMDMActions.FinishStageMdmLoadingProgression;
}
export class FinishAllMdmLoadingProgression implements Action{
  public readonly type = EMDMActions.FinishAllMdmLoadingProgression;
}


export type MDMActions =
  ClearMDMStore |
  InitMDMStore |

  LoadTypes |
  LoadTypesSuccess |
  LoadTypesFailure |

  LoadAllHierarchy |
  LoadAllHierarchySuccess |
  LoadAllHierarchyFailure |

  LoadHierarchyList |
  LoadHierarchyListSuccess |
  LoadHierarchyListFailure |

  LoadHierarchyLevels |
  LoadHierarchyLevelsSuccess |
  LoadHierarchyLevelsFailure |

  LoadHierarchyDetail |
  LoadHierarchyDetailSuccess |
  LoadHierarchyDetailFailure |

  StartMdmLoadingProgression |
  FinishStageMdmLoadingProgression |
  FinishAllMdmLoadingProgression;


